import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'linkrename',
})
export class LinkRename implements PipeTransform {

  transform(link: string): string {
    if (!link) return;
    // if (!link) return '-'; in current design it was decided to remove dash. But I will just comment this line. We know how it works )))
    const wwwIndex = link.indexOf('www');
    const httpsIndex = link.indexOf('//');
    const endIndex = link.charAt(link.length - 1) === '/' ? -1 : link.length;
    if (wwwIndex !== -1) return link.slice(wwwIndex + 4, endIndex);
    if (httpsIndex !== -1) return link.slice(httpsIndex + 2, endIndex);
    return link;
  }
}
